import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Help16 } from 'ui/icons/aurora/16px/Help16';
import { LinkButton } from 'ui/linkButton/LinkButton';
import { DOCS_URL } from '../constants';

export const DCB_DOC_LINK_DATA_TEST = 'dynamic-content-builder-doc-link';

export const HeaderBarContent = () => (
  <LinkButton
    data-test={DCB_DOC_LINK_DATA_TEST}
    isAngular
    rel="noopener noreferrer"
    size={BUTTON_SIZES.LARGE}
    target="_blank"
    to={DOCS_URL}
    variant={BUTTON_VARIANTS.GHOSTINVERTED}
  >
    <Help16 isColorInherited height={18} width={18} />
  </LinkButton>
);
